import { SimulationContent } from '../SimulationContent/SimulationContent';
import { DataUpload } from '../DataUpload/DataUpload';
import { PrefillConfig } from '../PrefillConfig/PrefillConfig';

type SandboxContentControlModesProps = {
  sandboxControllerMode?: string;
};

export const SimulationContentControlModes = ({ sandboxControllerMode }: SandboxContentControlModesProps) => {
  switch (sandboxControllerMode) {
    case 'anon_data_upload':
      return <DataUpload />;
    case 'simulation':
      return <SimulationContent />;
    case 'prefill_config':
      return <PrefillConfig />;
    default:
      return <DataUpload />;
  }
};
